import React from 'react';
import { faCalendarDays } from '@fortawesome/pro-regular-svg-icons/faCalendarDays';
import { DateRangePickerOption } from 'components/UI/V3/DateRangePicker/DateRangePicker';
import { DateRangePickerDropdown } from 'components/UI/V3/DateRangePickerDropdown';
import { DropdownContentProps } from 'components/UI/V3/Dropdown/Content/DropdownContent';
import styles from './FilterDateRangeRow.module.scss';
import { FilterRow } from './FilterRow';
import { Period } from '@spike/model';

interface FilterDateRangeRowProps {
    label: string;
    enabled: boolean;
    onToggle: () => void;
    value: Period | null;
    onChange: (val: Period | null) => void;
    options: Array<DateRangePickerOption>;
    timeZone: string;
    dropdownProps?: Partial<Omit<DropdownContentProps, 'children'>>;
}

export const FilterDateRangeRow: React.FC<FilterDateRangeRowProps> = ({
    label,
    enabled,
    onToggle,
    value,
    onChange,
    options,
    timeZone,
    dropdownProps
}) => (
    <FilterRow
        label={label}
        enabled={enabled}
        onToggle={onToggle}
    >
        <DateRangePickerDropdown
            timeZone={timeZone}
            value={value}
            onChange={onChange}
            options={options}
            buttonProps={{
                'variant': 'outlined',
                'leftIcon': faCalendarDays,
                'aria-label': 'Date range filter'
            }}
            dropdownProps={{
                className: styles.compactDropdown,
                showBottomModalOnMobile: false,
                ...dropdownProps
            }}
        />
    </FilterRow>
);
